module.exports = __webpack_public_path__ + "src/assets/animations/echinacea.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/echinacea.txt
// module id = ./src/assets/animations/echinacea.txt
// module chunks = 0